




































































































































import { Component, Vue } from "vue-property-decorator";
import LoaderFadeOut from "@/components/LoaderFadeOut.vue";

@Component({
  components: {
    LoaderFadeOut,
  },
})
export default class PageVerifyReport extends Vue {
  private reportId: string = "";
  private isLoading: boolean = false;
  private hasError: boolean = false;
  private currentUrl: string = "";
  private isPass: boolean = false;

  public async getReport() {
    const vm = this;

    if (vm.reportId.trim() === "") {
      return;
    }

    vm.hasError = false;
    vm.isLoading = true;
    vm.isPass = false;
    vm.currentUrl = "";

    const reportName = `${vm.reportId}.pdf`;
    const localUrl = `/certificates/${vm.reportId}.pdf`;
    const localSubFolderUrl = `/certificates/${vm.reportId.substr(0, 4)}/${
      vm.reportId
    }.pdf`;
    const apiUrl = `http://dreamxchange-001-site3.btempurl.com/api/certificates/DownloadAndOpen?id=${vm.reportId}`;

    // =================== [Get Local Report Main] ========================
    try {
      const xhrBlob = await vm.getReportLocal(localUrl);
      if (vm.checkValidReport(xhrBlob)) {
        vm.renderDocument(localUrl);
        return;
      }
    } catch {
      // continue to find out the report document.
    }

    // =================== [Get Local Report Sub] ========================
    try {
      const xhrBlob = await vm.getReportLocal(localSubFolderUrl);
      if (vm.checkValidReport(xhrBlob)) {
        vm.renderDocument(localSubFolderUrl);
        return;
      }
    } catch {
      // continue to find out the report document.
    }

    // =================== [Get Server Report] ========================
    try {
      await vm.getReportServer(apiUrl);
      vm.renderDocument(apiUrl);
      return;
    } catch {
      vm.isLoading = false;
      vm.reportId = "";
      vm.hasError = true;
    }
  }

  public mounted() {
    $(".parallax-mirror").hide();
  }

  private renderDocument(url: string) {
    this.isPass = true;
    this.currentUrl = url;
    this.isLoading = false;
    this.reportId = "";
  }

  private getReportServer(url: string) {
    // id: 1803SNV0075
    return $.ajax({
      method: "GET",
      url,
      crossDomain: true,
      xhrFields: {
        responseType: "blob",
        withCredentials: true,
      },
    });
  }

  private getReportLocal(url: string) {
    // id: 1803CDR9999
    // id: 1206_CDS0001 -> outter
    // id: 1206_CDR0001 -> inner
    return $.ajax({
      method: "GET",
      url,
      xhrFields: {
        responseType: "blob",
        withCredentials: true,
      },
    });
  }

  private checkValidReport(response: any) {
    const reg = /^application\/pdf/;
    return reg.test(response.type);
  }
}
